import OrbitApiV1 from '.'

class OrgAPI {
  static getOrgDetails(orgId, limit = 1000, details = 1) {
    return OrbitApiV1.httpGet(`/org/${orgId}?limit=${limit}&details=${details}`)
  }

  static getAllOrgsDetails(limit = 1000, details = 1) {
    return OrbitApiV1.httpGet(`/org/get?limit=${limit}&details=${details}&query={"disabled":{"$ne":true}}`)
  }

  static getAddress(query, limit = 1000) {
    return OrbitApiV1.httpGet(`/org/address?query=${query}&limit=${limit}`)
  }

  static createOrg(orgDetails) {
    return OrbitApiV1.httpPut(`/org/create`, {}, orgDetails)
  }

  static updateOrg(orgDetails) {
    return OrbitApiV1.httpPost(`/org/update`, {}, orgDetails)
  }

  static deleteOrg(orgId) {
    return OrbitApiV1.httpDelete(`/org/delete/${orgId}`)
  }

}

export default OrgAPI
